import React from 'react'

export default function Brand() {
    return (
        <div>Brand</div>
    )
}
